import CardsSlider from './CardsSlider';
export default CardsSlider;
